exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".categoryDetails[data-v-64b0e079]{font-size:.875rem;cursor:pointer}.editIcon.subcategory.material-icons.action-icon[data-v-64b0e079]{font-size:12px;position:relative;top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-64b0e079&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/SubcategoryDetailsBlock.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-64b0e079&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/SubcategoryDetailsBlock.vue
// module chunks = 0